import React, { PureComponent } from "react";
import { connect } from "react-redux";
import {
  initBudgetTree,
  setCurrentNavPage,
  setSubMenuDirection,
  setSubMenuDirectionToggle,
  setFilterClientGroup,
  setFilterClient,
  setFilterCollaborators,
  setFilterTaskCategory,
  setFilterYear
} from "Actions";
import BudgetTree from "./BudgetTree";
import { fetchBudgetTree, fetchNonCategorizedTaskTypeCount } from "Thunks";
import { HORIZONTAL, VERTICAL } from "Config";

class BudgetPage extends PureComponent {
  constructor(props) {
    super(props);
    let { uen } = this.props.match.params;

    this.state = { organizationUen: uen };
  }

  componentDidMount() {
    const { dispatch, subMenuDirection, budgetSheetFilter } = this.props;

    dispatch(setCurrentNavPage("BUDGET_PAGE"));

    if (subMenuDirection === VERTICAL) {
      dispatch(setSubMenuDirection(HORIZONTAL));
    }
    dispatch(setSubMenuDirectionToggle(false));

    let { uen } = this.props.match.params;
    this.setState({ organizationUen: uen });

    if (budgetSheetFilter.year.selected.length === 0) {
      dispatch(setFilterYear(new Date().getFullYear().toString()));
    }

    dispatch(initBudgetTree());
    dispatch(fetchBudgetTree());
    dispatch(fetchNonCategorizedTaskTypeCount());
  }

  componentWillUnmount() {
    const { dispatch } = this.props;
    dispatch(setSubMenuDirectionToggle(true));
    dispatch(setFilterCollaborators([]));
    dispatch(setFilterClient([]));
    dispatch(setFilterClientGroup([]));
    dispatch(setFilterTaskCategory([]));
    dispatch(setFilterYear([]));
  }

  render() {
    return (
      <div className={`page-content`}>
        <BudgetTree uen={this.state.organizationUen} />
      </div>
    );
  }
}

// Connected Component
const mapStateToProps = state => ({
  budgetSheetFilter: state.budget.filter,
  organization: state.timeSheet.organization,
  subMenuDirection: state.params.subMenuDirection,
  currentOrganization: state.auth.currentOrganization
});

export default connect(mapStateToProps)(BudgetPage);



// WEBPACK FOOTER //
// ./src/components/Budget/BudgetPage.js